import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";

import SEO from "../components/SEO";
import HeroSection from "../components/Homepage/HeroSection";
import NewListings from "../components/Homepage/PropertyListings";
import AgentsList from "../components/Homepage/AgentsList";
import ReportSection from "../components/Homepage/ReportsSection";
import ProfessionalsSection from "../components/Homepage/ProfessionalsSection";
import JoinRealty from "../components/Homepage/JoinRealty";
import PartnerProgram from "../components/Homepage/PartnerProgram";
import NeighborhoodHomes from "../components/Homepage/NeighborhoodHomes";

const Homepage = () => {
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    // Redirect to continue claim listing
    if (!auth) {
      const cld = JSON.parse(localStorage.getItem("acld") ?? null);
      if (cld && cld.lr) navigate(cld.lr);
    }
  }, [auth, navigate]);

  return (
    <div>
      <SEO>
        <title>BPO Homes - Find Your Dream Home Today</title>
        <meta
          name="og:title"
          content="BPO Homes - Find Your Dream Home Today"
        />
        <meta
          name="description"
          content="BPO Homes offers exclusive property listings across various neighborhoods. Explore our listings, connect with our agents, and find your dream home today. Join our Partner Agent Program for more benefits."
        />
        <meta
          name="og:description"
          content="BPO Homes offers exclusive property listings across various neighborhoods. Explore our listings, connect with our agents, and find your dream home today. Join our Partner Agent Program for more benefits."
        />
      </SEO>

      <Box component={"main"} sx={{ overflowX: "hidden" }}>
        <HeroSection />
        <NewListings listKey="new" styles={{ pb: 0 }} />
        <AgentsList styles={{ pb: 0 }} />
        <ReportSection />
        <ProfessionalsSection />
        <JoinRealty />
        <PartnerProgram />
        <NeighborhoodHomes />
      </Box>
    </div>
  );
};

export default Homepage;
